import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import FundViewOutlinedSvg from "@ant-design/icons-svg/es/asn/FundViewOutlined";
import AntdIcon from "../components/AntdIcon";
var FundViewOutlined = function FundViewOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FundViewOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  FundViewOutlined.displayName = 'FundViewOutlined';
}
export default /*#__PURE__*/React.forwardRef(FundViewOutlined);